import { render, staticRenderFns } from "./NikoTextarea.vue?vue&type=template&id=321f71d2&"
import script from "./NikoTextarea.vue?vue&type=script&lang=js&"
export * from "./NikoTextarea.vue?vue&type=script&lang=js&"
import style0 from "./NikoTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
